import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_2 = ["onInput", "value"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "svg-icon svg-icon-3" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "svg-icon svg-icon-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "pulse-ring start-25 top-0" }, null, -1)
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.getDiagnostics.length > 0)
    ? (_openBlock(), _createBlock(_component_Datatable, {
        key: 0,
        "enable-items-per-page-dropdown": _ctx.getDiagnostics.length > 10,
        "table-data": _ctx.getDiagnostics,
        "table-header": _ctx.tableHeader
      }, _createSlots({
        "cell-state": _withCtx(({ row: diagnostic }) => [
          (diagnostic.finished)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "btn btn-light-primary btn-sm fs-5",
                onClick: ($event: any) => (
          _ctx.$router.push({
            name: 'diagnostic-results',
            params: { diagnosticId: diagnostic.id },
          })
        )
              }, [
                _createElementVNode("span", _hoisted_4, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/graphs/gra004.svg" })
                ]),
                _createTextVNode(" Résultats ")
              ], 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "btn btn-light-warning btn-sm pulse pulse-warning fs-5",
                onClick: ($event: any) => (
          _ctx.$router.push({
            name: 'edit-diagnostic',
            params: { diagnosticId: diagnostic.id },
          })
        )
              }, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr029.svg" })
                ]),
                _hoisted_7,
                _createTextVNode(" Reprendre ")
              ], 8, _hoisted_5))
        ]),
        "cell-linkedExploitation": _withCtx(({ row: diagnostic }) => [
          _createTextVNode(_toDisplayString(_ctx.getExploitation(diagnostic.exploitation_id).name), 1)
        ]),
        "cell-date_evaluated": _withCtx(({ row: diagnostic }) => [
          _createTextVNode(_toDisplayString(new Date(diagnostic.date_evaluated).getFullYear()), 1)
        ]),
        "cell-status": _withCtx(({ row: diagnostic }) => [
          _createTextVNode(_toDisplayString(diagnostic.is_real ? "Réel" : "Simulé"), 1)
        ]),
        "cell-score": _withCtx(({ row: diagnostic }) => [
          _createTextVNode(_toDisplayString(diagnostic.finished
          ? _ctx.getDiagnosticScore(diagnostic.id)
          : diagnostic.results.length +
            " / " +
            _ctx.getFactorsNumber.toString() +
            " Facteurs"), 1)
        ]),
        _: 2
      }, [
        (_ctx.selectable)
          ? {
              name: "cell-radio",
              fn: _withCtx(({ row: diagnostic }) => [
                _createElementVNode("div", _hoisted_1, [
                  _withDirectives(_createElementVNode("input", {
                    onInput: ($event: any) => (_ctx.diagnosticChoiceEmit(diagnostic.id)),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.diagnosticChoice) = $event)),
                    value: diagnostic.id,
                    class: "form-check-input",
                    type: "radio"
                  }, null, 40, _hoisted_2), [
                    [_vModelRadio, _ctx.diagnosticChoice]
                  ])
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["enable-items-per-page-dropdown", "table-data", "table-header"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, "Aucun diagnostic"))
}